export const TIMERS_ENUM = {
  timeoutDelay: 1000,
  cancelTimeout: 120,
  toSeconds: 1000,
};
